import React, { useState } from 'react';
import { Modal, Button} from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { 
  deleteIngredient,

} from '../../../../../../crud/menu_api/ingredients';
import MiniLoadingSpinner from '../../../../../../components/Spinners/MiniLoadingSpinner';

import { Ingredient } from '../../types';

interface ModalProps {
  show: boolean;
  handleClose: () => void;
  categoryId?: string;
  ingredients: any[]; 
  setIngredients: any;
  setOriginalIngredients: (data: Ingredient[]) => void; 
}

interface DeleteModalProps extends ModalProps {
  ingredientId: number | null;
  originalIngredients: Ingredient[];
  setIngredient: (data: any[]) => void;
}

export interface Option {
    id: number;
    name: string;
  }



const DeleteIngredient: React.FC<DeleteModalProps> = ({ show, handleClose, ingredientId, ingredients,setIngredients, originalIngredients, setIngredient, setOriginalIngredients }) => {
    const [loading, setLoading] = useState(false);
    const handleDelete = () => {
        setLoading(true);
        deleteIngredient(ingredientId!).then((response) => {
            if (response) {
            toast.success('Ingrediente eliminado exitosamente');
            const updatedOriginalIngredients = originalIngredients.filter(ing => ing.ingredient_id !== ingredientId);
            setIngredients(updatedOriginalIngredients);
            setIngredient(updatedOriginalIngredients);
            setOriginalIngredients(updatedOriginalIngredients);
            handleClose();
            }
        }).catch((error) => {
            console.error(error);
            toast.error('Error al eliminar el ingrediente \n' + error.response.data.message );
        }).finally(() => {
            setLoading(false)
            });
        };
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
      <div className='form-modal-title-container'>
        <Modal.Title className='form-modal-title' >Eliminar Ingrediente</Modal.Title>
      </div>
        <Button variant="none" onClick={handleClose}>
          <X size={24} />
        </Button>
      </Modal.Header>
      {loading && <MiniLoadingSpinner/>}
      {!loading &&
      <Modal.Body>
        <p>¿Estás seguro que quieres eliminar este ingrediente?</p>
      </Modal.Body>
        }
      <Modal.Footer>
      <div className="form-modal-footer-custom">
        <Button className="form-button-cancel" onClick={handleClose}>Cancelar</Button>
        <Button className="form-button-create" disabled={loading} onClick={handleDelete}>Eliminar</Button>
      </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteIngredient;